export default __webpack_public_path__ + "static/media/5star.bc97e229.svg";